import { render, staticRenderFns } from "./modal-20-percent.vue?vue&type=template&id=8870ed10&scoped=true"
import script from "./modal-20-percent.vue?vue&type=script&lang=js"
export * from "./modal-20-percent.vue?vue&type=script&lang=js"
import style0 from "./modal-20-percent.vue?vue&type=style&index=0&id=8870ed10&prod&lang=scss"
import style1 from "./modal-20-percent.vue?vue&type=style&index=1&id=8870ed10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8870ed10",
  null
  
)

export default component.exports